import { Container, Typography } from '@pwskills/rachnaui';
import React, { useContext } from 'react';
import CheckMarkIcon from '../../../assets/icons/CheckMarkIcon';
import CategoryPageContext from '../../../context/CategoryPageContext';
import VideoComponent from '../VideoContainer';

const CategoryHighlights = () => {
  const { categoryDetails } = useContext(CategoryPageContext);
  const title = categoryDetails?.title;
  const aboutCategory = categoryDetails?.about;
  const pointers = aboutCategory?.coursePointers;

  /* CategoryHighlights page */
  return (
    <Container className="medium:!px-8 large:!px-20  ">
      <div className="flex flex-col large:!flex-row large:!bg-white large:!rounded-xl py-14 large:!px-[42px] w-full gap-6 ">
        <div className="flex flex-col gap-6">
          <div>
            <Typography
              component="h2"
              variant="bold"
              className="text-gray-900 font-inter medium:!text-[32px] large:!text-[48px] leading-9 medium:!leading-10 large:!leading-[60px]"
            >
              {title} Highlights
            </Typography>
          </div>

          <div>
            <Typography
              component="body-small"
              variant="regular"
              className="text-gray-650 !text-[16px] leading-6"
            >
              {aboutCategory?.description}
            </Typography>
          </div>

          {/* for medium screens  */}
          <div className="hidden medium:!grid grid-cols-2 gap-6 large:!hidden">
            {pointers?.map((item) => {
              return (
                <div className="flex flex-col pr-4 py-2 gap-2">
                  <div className="flex gap-2 items-center">
                    <CheckMarkIcon />
                    <Typography variant="bold" component="body-regular" className="text-[16px]">
                      {item.title}
                    </Typography>
                  </div>
                  <Typography
                    variant="regular"
                    component="body-small"
                    className="text-[#757575] text-[14px] line-clamp-2"
                  >
                    {item.subText}
                  </Typography>
                </div>
              );
            })}
          </div>

          {/* for small and large screens */}
          <div className="medium:hidden large:!flex flex-col gap-6">
            {pointers?.map((item) => {
              return (
                <div className="flex flex-col pr-4 py-2 gap-2 w-full large:!w-[302px]">
                  <div className="flex gap-2 items-center">
                    <CheckMarkIcon />
                    <Typography variant="bold" component="body-regular" className="!text-[16px]">
                      {item.title}
                    </Typography>
                  </div>
                  <Typography
                    variant="regular"
                    component="body-small"
                    className="text-[#757575] !text-[14px] line-clamp-2"
                  >
                    {item.subText}
                  </Typography>
                </div>
              );
            })}
          </div>
        </div>

        <div className="flex self-center items-center !w-full large:!max-w-[543px] rounded-xl">
          {aboutCategory?.videoUrl ? (
            <div className="h-[300px] medium:h-[590px] w-full  rounded-[20px] ">
              <VideoComponent url={aboutCategory?.videoUrl} />
            </div>
          ) : (
            aboutCategory?.thumbnailUrl && (
              <img
                src={`${aboutCategory?.thumbnailUrl}`}
                width={543}
                height={626}
                alt={`${aboutCategory?.altText}`}
                className="w-full rounded-xl"
              />
            )
          )}
        </div>
      </div>
    </Container>
  );
};

export default CategoryHighlights;
